import "./layer.scss";
import Language from "../../language.js";
const lang = new Language();

const layer = {
	msg: (title, opt, fn) => {
		const layerHtml = `<div class="plugin-layer-box msg">${title}</div>`;
		$("body").append(layerHtml);

		if (opt) {
			setTimeout(() => {
				fn();
				$(".plugin-layer-box").remove();
			}, opt.time);
		} else {
			setTimeout(() => {
				$(".plugin-layer-box").remove();
			}, 2000);
		}
	},
	dialog: (title, btns, fun) => {
		const layerBox = document.createElement("div");
		layerBox.classList = "plugin-layer-box dialog";
		const layerMask = document.createElement("div");
		layerMask.className = "plugin-layer-mask";
		layerMask.addEventListener(
			"click",
			function () {
				$(".plugin-layer-box").remove();
			},
			false
		);
		const layerMain = document.createElement("div");
		layerMain.className = "plugin-layer-main";
		const layerContent = document.createElement("div");
		layerContent.className = "plugin-layer-content";
		layerContent.innerHTML = title;
		const layerBtns = document.createElement("div");
		layerBtns.className = "plugin-layer-btns";
		for (let i = 0; i < btns.length; i++) {
			const btnItem = document.createElement("span");
			btnItem.className = "plugin-layer-btn";
			btnItem.innerHTML = btns[i];
			layerBtns.appendChild(btnItem);
			btnItem.addEventListener(
				"click",
				function () {
					$(".plugin-layer-box").remove();
					fun[i]();
				},
				false
			);
		}
		layerBox.appendChild(layerMask);
		layerMask.appendChild(layerMain);
		layerMain.appendChild(layerContent);
		layerMain.appendChild(layerBtns);
		$("body").append(layerBox);
	},
	confirmVotingResult: (func) => {
		const layerHtml = document.createElement("div");
		const html =
			`<div class="dta-layer" style="display: none">
						<div class="dtal-bg"></div>
						<div class="dtal-main">
							<div class="dtal-content mw-900 bg-white text-center">
								<span class="dtal-close btn-close icon-close black"></span>
								<h3 class="fz-40 lts-50 fw-500 black mt-160">` +
			lang.confirmVotingResult +
			`</h3>
								<div class="mt-40 text-center">
									<div class="fz-20 black comm-desc">
										<p>` +
			lang.cannotBeModified +
			`</p>
									</div>
								</div>

								<ul class="list list-2 list-default mt-160">
									<li>
										<a href="javascript:;" type="submit" class="btn-more btn-confirm center blue">
											<div class="btn-more__wrap">
												<span>` +
			lang.btnConfirm +
			`</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:;" type="submit" class="btn-more btn-cancel center white border-top">
											<div class="btn-more__wrap">
												<span>` +
			lang.btnLater +
			`</span>
											</div>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>`;

		layerHtml.innerHTML = html;

		const btnClose = layerHtml.querySelector(".btn-close");
		const btnConfirm = layerHtml.querySelector(".btn-confirm");
		const btnCancel = layerHtml.querySelector(".btn-cancel");

		btnClose.addEventListener("click", function () {
			layerHtml.remove();
		});
		btnCancel.addEventListener("click", function () {
			layerHtml.remove();
		});
		btnConfirm.addEventListener("click", function () {
			func();
			layerHtml.remove();
		});

		document.body.appendChild(layerHtml);
		$(".dta-layer").fadeIn("fast");
	},
	confirmVoteScore: (func) => {
		const layerHtml = document.createElement("div");
		const html =
			`<div class="dta-layer" style="display: none">
						<div class="dtal-bg"></div>
						<div class="dtal-main">
							<div class="dtal-content mw-900 bg-white">
								<span class="dtal-close btn-close icon-close black"></span>
								<div class="mw-560 margin-auto">
									<h3 class="fz-40 lts-50 fw-500 black mt-160">作品评分：</h3>
									<div class="mt-40"></div>
									<input class="vw-checkbox" type="checkbox" name="score" id="score1" value="1">
									<label class="vw-checkbox-label" for="score1">审美性（1分）</label>
									<input class="vw-checkbox" type="checkbox" name="score" id="score2" value="2">
									<label class="vw-checkbox-label" for="score2">创新性（1分）</label>
								</div>
								<ul class="list list-2 list-default mt-160">
									<li>
										<a href="javascript:;" type="submit" class="btn-more btn-confirm center blue">
											<div class="btn-more__wrap">
												<span>` +
			lang.btnConfirm +
			`</span>
											</div>
										</a>
									</li>
									<li>
										<a href="javascript:;" type="submit" class="btn-more btn-cancel center white border-top">
											<div class="btn-more__wrap">
												<span>` +
			lang.btnLater +
			`</span>
											</div>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>`;

		layerHtml.innerHTML = html;

		const btnClose = layerHtml.querySelector(".btn-close");
		const btnConfirm = layerHtml.querySelector(".btn-confirm");
		const btnCancel = layerHtml.querySelector(".btn-cancel");

		btnClose.addEventListener("click", function () {
			layerHtml.remove();
		});
		btnCancel.addEventListener("click", function () {
			layerHtml.remove();
		});
		btnConfirm.addEventListener("click", function () {
			func();
			layerHtml.remove();
		});

		document.body.appendChild(layerHtml);
		$(".dta-layer").fadeIn("fast");
	},
};

export { layer };
